module.exports = function() {
  return new Worker(__webpack_public_path__ + "31c5c6ee83ea02e73d68.worker.js");
};